export const theme = {
  token: {
    colorPrimary: "#1976D2",
  },
};
